import { get } from "@/api/public.client";
import { ExternalLinkIcon } from "@radix-ui/react-icons";
import Link from "next/link";
import { useEffect, useState } from "react";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { PaymentStatusBubble } from "./payment-status-bubble";
import { ReservationStatusBubble } from "./reservation-status-bubble";

export function CartSwitcherOrder({ orderReference }: any) {
  const [loading, setLoading] = useState(true);
  const [eventId, setEventId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [reservationStatus, setReservationStatus] = useState("");

  useEffect(() => {
    get("/public/order/{order_reference}", {
      params: {
        path: {
          order_reference: orderReference,
        },
      },
    }).then((fetchResponse: any) => {
      if (fetchResponse.error) {
      } else {
        setEventId(fetchResponse.data.eventId);
        setPaymentStatus(fetchResponse.data.paymentStatus);
        setReservationStatus(fetchResponse.data.reservationStatus);
        setLoading(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Link
      href={"/events/" + eventId + "/order/" + orderReference}
      className="flex group"
      target="_parent"
    >
      <DropdownMenuItem className="cursor-pointer">
        <div className="flex w-10">
          <PaymentStatusBubble paymentStatus={paymentStatus} />{" "}
          <ReservationStatusBubble reservationStatus={reservationStatus} />{" "}
        </div>
        <div className="inline-block ml-2 font-mono">{orderReference} </div>
        <div className="inline-block ml-2">
          <ExternalLinkIcon className="w-4 h-5 opacity-0 group-hover:opacity-50" />
        </div>
      </DropdownMenuItem>
    </Link>
  );
}
